<template>
  <div class="mv-bg-main" style="overflow: scroll;">
    <el-card class="mr">
      <el-row>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">供应商待核算单</p>
            <p class="center_task" style="color: #7FFFAA;">{{supCheck}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">客户待核算单</p>
            <p class="center_task" style="color: #FFA500;">{{custCheck}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">支付平台待核算单</p>
            <p class="center_task" style="color: #19CAAD;">{{payCheck}}</p>
          </div>
        </el-col>
      </el-row>
      <el-row class="">
        <el-col :span="8">
          <div class="task">
            <p class="center_task">供应商待结算单</p>
            <p class="center_task" style="color: #FF69B4;">{{supSettlement}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">客户待结算单</p>
            <p class="center_task" style="color: #0000CD;">{{custSettlement}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="task">
            <p class="center_task">支付平台待结算单</p>
            <p class="center_task" style="color: #00BFFF;">{{paySettlement}}</p>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="mr">
      <div slot="header" class="clearfix">
        <span class="card-title">客户调账排行</span>
      </div>
      <el-row>
        <el-col :span="12">
          <span class="cursor" v-bind:class="{ color: consumeDayColor }" @click="consumeDay"> 月</span>
          <span class="cursor" v-bind:class="{ color: consumeMonthColor }" @click="consumeMonth">年</span>
        </el-col>
        <el-col :span="12">
          <!-- <el-button type="primary" style="float: right;" size="small">完整排行</el-button> -->
        </el-col>
      </el-row>
      <el-table
        :data="tableCusData"
        style="width: 100%;margin-top: 10px;">
        <el-table-column
          label="排名"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          label="客户"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.custName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调账笔数"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.adjustCount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调账金额"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.adjustAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="调账频率"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <el-progress :stroke-width="14" :text-inside="true" :percentage="parseInt(scope.row.adjustRate * 100)"></el-progress>
            <!-- <i class="iconfont icon-shuzhixiajiang" ></i> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="pageNum"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.cursor {
  cursor: pointer;
}
.color {
  color: #00c2de;
  cursor: pointer;
}
.color:hover {
  cursor: pointer;
  text-decoration: underline;
}
.mr {
  margin: 10px;
}
.task {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 80px;
}
.center_task {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
.float {
  float: left;
}
</style>
<script>
export default {
  name: 'accountingAnalysis',
  data () {
    return {
      tableCusData: [],
      consumeDayColor: true,
      consumeMonthColor: false,
      dateConsumeType: 2,
      supCheck: '',
      custCheck: '',
      payCheck: '',
      supSettlement: '',
      custSettlement: '',
      paySettlement: '',
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tooltip: true
    }
  },
  created () {
    this.query()
    this.queryAccount()
  },
  methods: {
    consumeDay () {
      this.dateConsumeType = 2
      this.consumeMonthColor = false
      this.consumeDayColor = true
      this.queryAccount()
    },
    consumeMonth () {
      this.dateConsumeType = 3
      this.consumeMonthColor = true
      this.consumeDayColor = false
      this.queryAccount()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryAccount()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryAccount()
    },
    queryAccount () {
      let op = {}
      op.dateType = this.dateConsumeType
      op.sysIds = []
      op.pageNum = this.pageNum
      op.pageSize = this.pageSize
      this.$axios({
        url: this.$API.analysis.queryCustAdjustRank,
        method: 'post',
        data: op
      }).then((response) => {
        let data = response.data.resData.resultList
        this.tableCusData = data
        this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    },
    query () {
      /* 查询待核算待结算个数 */
      this.$axios({
        url: this.$API.analysis.queryBillStatistic,
        method: 'post',
        data: {sysIds: []}
      }).then((response) => {
        let data = response.data.resData
        this.supCheck = data.supCheck
        this.custCheck = data.custCheck
        this.payCheck = data.payCheck
        this.supSettlement = data.supSettlement
        this.custSettlement = data.custSettlement
        this.paySettlement = data.paySettlement
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/accountingAnalysis.vue